import { IGroup, IPlayerGroup } from "@grassrootly/api/entities";
import withErrorCheck from "../CheckError";
import { GetGroupByIdPayload } from "@grassrootly/api/gateways";
import server from "../Server";

export const GetGroupById = async (payload: GetGroupByIdPayload): Promise<IPlayerGroup | null> => {
  const groupMember =
    withErrorCheck(
      await server.from("GroupPlayers").select("*").eq("player_id", payload.playerId).eq("group_id", payload.id)
    )?.[0] || null;

  const group = withErrorCheck(await server.from("Groups").select("*").eq("id", payload.id))?.[0] || null;
  if (!group) return null;

  return { ...group, is_owner: !!groupMember?.is_owner, is_member: !!groupMember };
};
